<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row mb-4">
    <div class="col-12">
      <div class="mb-2">
        <input class="form-control" formControlName="code" inputValidator label="{{ 'CITY.CODE' | translate }}"
               maxlength="7">
      </div>
    </div>
    <div class="col-12">
      <div>
        <input class="form-control" formControlName="name" inputValidator label="{{ 'CITY.NAME' | translate }}">
      </div>
    </div>
    <div class="col-12">
      <div>
        <input class="form-control" formControlName="model" inputValidator label="{{ 'METER_TYPE.MODEL' | translate }}">
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProvidersService.getAll.bind(utilityProvidersService)"
          formControlName="utilityProviderId"
          inputValidator
          label="MENU.UTILITY_PROVIDERS"
        />
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProviderTypesService.getAll.bind(utilityProviderTypesService)"
          [parentControl]="form.get('utilityProviderId')"
          formControlName="utilityProviderTypeId"
          inputValidator
          label="METER_TYPE.UTILITY_TYPE"
        >
        </autocomplete>
      </div>
    </div>
    <div class="col-12">
      <div>
        <input class="form-control" formControlName="manufacture" inputValidator
               label="{{ 'METER_TYPE.MANUFACTURE' | translate }}">
      </div>
    </div>
    <div class="col-12">
      <p-calendar label="{{ 'METER_TYPE.MANUFACTURE_DATE' | translate }}" formControlName="manufactureDate" inputValidator/>
    </div>
    <div class="col-12">
      <div>
        <input class="form-control" formControlName="capacity" inputValidator
               label="{{ 'METER_TYPE.CAPACITY' | translate }}">
      </div>
    </div>
    <div class="col-12">
      <div class="form-check form-switch mt-2">
        <input class="form-check-input" formControlName="certification" role="switch" type="checkbox">
        <label class="form-check-label">{{ 'METER_TYPE.CERTIFICATION' | translate }}</label>
      </div>
    </div>
    <div class="col-12">
      <div>
        <input class="form-control" formControlName="certificationBody" inputValidator
               label="{{ 'METER_TYPE.CERTIFICATION_BODY' | translate }}">
      </div>
    </div>

    @if (isEdit) {
      <div class="col-12">
        <div class="form-check form-switch mt-2">
          <input formControlName="status" class="form-check-input" type="checkbox" role="switch">
          <label class="form-check-label">{{ 'CITY.STATUS' | translate }}</label>
        </div>
      </div>
    }
  </div>

  <div class="text-end d-flex gap-2 justify-content-end">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
    <button class="btn btn-soft-primary" (click)="cancel()" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
